var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40385 2C6.58481 2 5.09532 2.22264 4.13969 3.24413C3.20325 4.24509 3 5.78725 3 7.71155V18.5385C3 19.3164 3.1847 19.9878 3.5775 20.5305C3.9683 21.0705 4.50671 21.4024 5.07083 21.6085C6.14245 22 7.50907 22 8.66405 22H15.4129C16.5679 22 17.9345 22 19.0061 21.6085C19.5702 21.4024 20.1086 21.0705 20.4994 20.5305C20.8922 19.9878 21.0769 19.3164 21.0769 18.5385L21.0769 7.71155C21.0769 5.78725 20.8737 4.24509 19.9372 3.24413C18.9816 2.22264 17.4921 2 15.6731 2H8.40385ZM19.3461 7.71155C19.3461 5.76084 19.0975 4.87992 18.6733 4.42655C18.2684 3.99371 17.4886 3.73077 15.6731 3.73077H8.40385C6.58827 3.73077 5.80853 3.99371 5.40358 4.42655C4.97944 4.87992 4.73077 5.76084 4.73077 7.71155V18.5385C4.73077 19.0394 4.84655 19.3319 4.97959 19.5158C5.11463 19.7023 5.32742 19.8596 5.66475 19.9828C6.39322 20.249 7.42611 20.2692 8.67308 20.2692H15.4038C16.6508 20.2692 17.6837 20.249 18.4122 19.9828C18.7495 19.8596 18.9623 19.7023 19.0973 19.5158C19.2304 19.3319 19.3461 19.0394 19.3461 18.5385L19.3461 7.71155Z",
    fill: "#0F1653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7376 8.6721L8.58547 12.8243C8.42126 12.9885 8.26876 13.2934 8.23357 13.5163L8.01071 15.0998C7.92861 15.6745 8.32741 16.0733 8.90215 15.9912L10.4856 15.7683C10.7085 15.7332 11.0252 15.5807 11.1776 15.4164L15.3298 11.2643C16.0453 10.5488 16.3854 9.71603 15.3298 8.6604C14.2859 7.61649 13.4531 7.95661 12.7376 8.6721Z",
    stroke: "#0F1653",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1372 9.27026C12.4891 10.537 13.4743 11.5223 14.7411 11.8742",
    stroke: "#0F1653",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.7f8c56fa30ce5f0c1ed97c8052fe6eb5.svg";
export { ForwardRef as ReactComponent };